import React, { useMemo } from 'react'
import styles from './index.module.scss'

const PracticeTable = ({ data }) => {
  const grouped = useMemo(() => {
    if (!data?.length) return []
    const map = new Map()
    data.forEach(item => {
      const key = item.practice_kind || ''
      if (!map.has(key)) map.set(key, [])
      map.get(key).push(item)
    })
    return Array.from(map, ([kind, items]) => ({ kind, items }))
  }, [data])

  if (!data?.length) return null

  return (
    <div className={styles.practiceSection}>
      <div className={styles.practiceHeader}>
        <h3>Практика</h3>
        {/* <span className={styles.counter}>{data.length}</span> */}
      </div>

      <table className={styles.practiceTable}>
        <thead>
          <tr>
            <th>Основные виды практики</th>
            <th>Тип практики</th>
            {/* <th>Часть программы</th> */}
          </tr>
        </thead>
        <tbody>
          {grouped.map(({ kind, items }) => (
            <React.Fragment key={kind}>
              {items.map((item, idx) => (
                <tr key={`${kind}-${idx}`}>
                  {idx === 0 && (
                    <td className={styles.kindCell} rowSpan={items.length}>
                      {kind}
                    </td>
                  )}
                  <td>{item.practice_type}</td>
                  {/* <td>{item.programm_part || ''}</td> */}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default PracticeTable
